<template>
    <div>
        <p>Trigger a webhook to <em>{{action.url}}</em> using <em>{{action.method}}</em>.</p>
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'trigger-webhook-summary',
        extends: BaseActionSummary,
    };
</script>
